module.exports = __webpack_public_path__ + "static/img/gg-cn-btn.e2e7d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/gg/gg-cn-btn.png
// module id = 3CKF
// module chunks = 1